@let state = data();
@if (state === null || state.isLoading) {
  <div
    class="@container flex flex-col gap-5 px-6 pt-5 pb-4 rounded-lg outline outline-1 outline-offset-[-1px] outline-outline dark:outline-outline-darkmode"
  >
    <div class="flex gap-2 items-center">
      <ui-skeleton class="flex-none rounded-full size-5" />
      <ui-skeleton class="flex-1 h-3 w-full rounded-lg" />
      <ui-skeleton class="w-[116px] h-10 flex-none rounded-md" />
    </div>

    <div class="grid grid-cols-1 @md:grid-cols-2 gap-3">
      <div
        class="p-3 bg-surface-variant dark:bg-surface-variant-darkmode rounded-md flex flex-col gap-0.5"
      >
        <ui-skeleton class="block h-3 w-[50%] rounded-full" />
        <div class="grid grid-cols-2 gap-0.5 items-end">
          <ui-skeleton class="inline-block h-11 w-full rounded-full" />
          <ui-skeleton class="inline-block h-4.5 w-full rounded-full" />
        </div>
      </div>

      <div
        class="p-3 bg-surface-variant dark:bg-surface-variant-darkmode rounded-md flex flex-col gap-0.5"
      >
        <ui-skeleton class="block h-3 w-[50%] rounded-full" />
        <div class="grid grid-cols-2 gap-0.5 items-end">
          <ui-skeleton class="inline-block h-11 w-full rounded-full" />
          <ui-skeleton class="inline-block h-4.5 w-full rounded-full" />
        </div>
      </div>
    </div>
    <ui-skeleton class="block w-full h-10 rounded-md" />
  </div>
} @else {
  <div
    class="@container flex flex-col gap-5 px-6 pt-5 pb-4 rounded-lg outline outline-1 outline-offset-[-1px] outline-outline dark:outline-outline-darkmode"
  >
    @if (state.error) {
      <app-error-component
        class="block h-[206px]"
        (clickRetry)="onClickReload()"
        [enableRetry]="true"
      />
    } @else {
      <div class="flex gap-2 items-center">
        <ng-icon name="heroChartBar" size="20" class="flex-none !block" />
        <span class="flex-1 text-base font-semibold leading-6 line-clamp-1">
          {{ 'cockpit.analysis.consumption.title' | transloco }}
        </span>
        <ui-switch-bar
          [formField]="consumptionForm.data.utilityType"
          (valueChange)="onChangeUtilityType()"
          class="w-[78px] inline-block flex-none"
        >
          <ui-switch-bar-option value="ELECTRICITY">
            <ng-icon name="heroBolt" size="20" class="!block" />
          </ui-switch-bar-option>
          <ui-switch-bar-option value="GAS">
            <ng-icon name="heroFire" size="20" class="!block" />
          </ui-switch-bar-option>
        </ui-switch-bar>
      </div>

      <div class="grid grid-cols-1 @md:grid-cols-2 gap-3">
        <div
          class="p-3 bg-surface-variant dark:bg-surface-variant-darkmode rounded-md flex flex-col gap-0.5"
        >
          <div
            class="text-on-surface-subtle dark:text-on-surface-subtle-darkmode text-sm font-normal leading-5"
          >
            {{ 'cockpit.analysis.consumption.totalConsumption' | transloco }}
          </div>
          @let total = state.data?.usageSummary?.total;
          @if (total !== null && total !== undefined) {
            <app-responsive-value [value]="total | germanNumber: 0">{{
              'cockpit.analysis.consumption.unitKwh' | transloco
            }}</app-responsive-value>
          }
        </div>

        <div
          class="p-3 bg-surface-variant dark:bg-surface-variant-darkmode rounded-md flex flex-col gap-0.5"
        >
          <div
            class="text-on-surface-subtle dark:text-on-surface-subtle-darkmode text-sm font-normal leading-5"
          >
            {{ 'cockpit.analysis.consumption.peakLoad' | transloco }}
          </div>
          @let peakLoad = state.data?.loadSummary?.highestWithoutOutliers;
          @if (peakLoad !== null && peakLoad !== undefined) {
            <app-responsive-value [value]="peakLoad | germanNumber: 0">{{
              'cockpit.analysis.consumption.unitKw' | transloco
            }}</app-responsive-value>
          }
        </div>
      </div>

      <ui-button
        mode="outlined"
        expand="full"
        class="w-full block"
        routerLink="./consumption"
        data-track="analysis-consumption-view-button"
      >
        {{ 'cockpit.analysis.consumption.viewConsumptions' | transloco }}
        <ng-icon name="heroArrowRight" size="20" slot="end" class="!block" />
      </ui-button>
    }
  </div>
}
